import { render } from "./DocumentosRegistro.vue?vue&type=template&id=190c2ce4"
import script from "./DocumentosRegistro.vue?vue&type=script&lang=js"
export * from "./DocumentosRegistro.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__